'use strict';

const staticPages = {
    init: function () {
        $(document).on('ready', function () {
            var firstQue = $(".experience-assets-questionandanswer").first();
            $(firstQue).find('.answer').toggleClass('hide');
            $(firstQue).find('.question').toggleClass('downArrow');
            $(firstQue).find('.question').toggleClass('upArrow');
        });

        $(document).on('click', '.question', function (e) {
            var parentEl = $(this).parent().closest('.experience-assets-questionandanswer');
            $(parentEl).addClass('active');
            if ($(parentEl).hasClass('active')) {
                $(parentEl).find('.answer').toggleClass('hide');
                $(parentEl).find('.question').toggleClass('downArrow');
                $(parentEl).find('.question').toggleClass('upArrow');
                $('.experience-assets-questionandanswer').not('.active').find('.answer').addClass('hide');
                $('.experience-assets-questionandanswer').not('.active').find('.question').addClass('downArrow');
                $('.experience-assets-questionandanswer').not('.active').find('.question').removeClass('upArrow');
            }
            $(parentEl).removeClass('active');
        })
    }
}

export default {
    init() {
        staticPages.init();
    },
};
